module.exports = __webpack_public_path__ + "bce614be3fa2dcafada340b6c050f663.MP3";